import { buildHref } from "@softmax/web-addresses";
import {
  type LobbyState,
  type PlaySessionState,
} from "@/features/lobby-operations/state";
import { requireAccountSession } from "@/features/account/records";
import { resourceHref, type ResourceInput } from "./resource-search";
import { readResource, canonicalizeResource } from "./resource-reader";
export async function loadLobby({
  signal,
  data: input,
}: {
  signal?: AbortSignal | undefined;
  data: ResourceInput;
}) {
  const destination = { name: "lobby", lobbyId: input.resourceId } as const;
  const returnHref = resourceHref({
    input,
    destination,
  });
  await requireAccountSession({ returnHref, signal });

  const {
    resource: lobby,
    viewer,
    generatedAt,
  } = await readResource<LobbyState>({
    signal,
    path: `/v2/lobbies/${encodeURIComponent(input.resourceId)}`,
    returnHref,
  });
  canonicalizeResource({
    input,
    destination,
    canonical: buildHref({ ...destination, game: lobby.game_address }),
  });
  return { lobby, viewer, generatedAt };
}
export async function loadPlaySession({
  signal,
  data: input,
}: {
  signal?: AbortSignal | undefined;
  data: ResourceInput;
}) {
  const destination = {
    name: "playSession",
    sessionId: input.resourceId,
  } as const;
  const {
    resource: session,
    viewer,
    generatedAt,
  } = await readResource<PlaySessionState>({
    signal,
    path: `/v2/coworlds/play/session/${encodeURIComponent(input.resourceId)}`,
    returnHref: resourceHref({
      input,
      destination,
    }),
  });
  canonicalizeResource({
    input,
    destination,
    canonical: buildHref({ ...destination, game: session.game_address }),
  });
  return {
    sessionId: input.resourceId,
    session,
    viewer,
    generatedAt,
  };
}
